module.exports = __webpack_public_path__ + "static/media/reiki-stories.43ad4221.png";